import type { Guide } from '../types';

/**
 * S-26.10-12 — rozliczenie zlecenia (prace 26.10.2026, pakiet P4b; scenariusz e2e 38). Rekordy z danych
 * pokazowych: DEMO/2026/10/RZ1 (zrealizowane, postój zmierzony przy rozładunku — do decyzji) i RZ2
 * (rozliczenie przekazane do fakturowania). Nagrywarka niczego nie zapisuje.
 */
export const guide: Guide = {
  flagKey: 'orderSettlement',
  title: 'Rozliczenie zlecenia: postój, korekty, przekazanie do fakturowania',
  whatItDoes:
    'Administracja rozlicza zlecenia zrealizowane: widzi fracht, postój przy punktach wyliczony z czasu na miejscu według śladu GPS (szacunek, ze źródłem), korektę paliwową i awizacje jako informację. Decyduje „Nalicz postój” albo „Nie naliczaj” z powodem, dodaje korekty z powodem i przekazuje rozliczenie do fakturowania — to tylko status w aplikacji, fakturę wystawia się poza nią. Bez decyzji o postoju przekazać się nie da. Stawka postoju i czas bezpłatny to parametry z historią. Każda decyzja zostaje w historii zlecenia z autorem.',
  audience: ['Administracja', 'CS (podgląd)', 'administrator'],
  presentationItems: ['S-26.10-12'],
  steps: [
    {
      route: '/intake-dashboard',
      target: 'intake-tile-settlementsOpen',
      title: 'Kafelek „Do rozliczenia”',
      description:
        'Na pulpicie przyjęcia zleceń Administracja widzi, ile zleceń zrealizowanych z ostatnich 60 dni czeka na rozliczenie. Kafelek prowadzi do ekranu „Rozliczenie”.',
      action: 'Kliknij kafelek „Do rozliczenia”.',
      recorder: { account: 'adm' },
    },
    {
      route: '/settlements',
      target: 'settlement-stop',
      mockupTestId: 'adm-rozliczenie-postoj-nalicz',
      title: 'Postój ze śladu GPS — szacunek',
      description:
        'Przy każdym punkcie: kiedy auto stało na miejscu według śladu GPS, ile to trwało i ile ponad czas bezpłatny. Punkt bez pomiaru ma powód (np. auto bez telematyki) — brak to brak, nie zero. Opis mówi, jaka stawka i jaki czas bezpłatny zostały użyte.',
      action: 'Wybierz zlecenie z listy i sprawdź postój przy punktach.',
      recorder: {
        account: 'adm',
        actions: [{ kind: 'clickText', text: 'DEMO/2026/10/RZ1' }],
      },
    },
    {
      route: '/settlements',
      target: 'adm-rozliczenie-fakturuj',
      mockupTestId: 'adm-rozliczenie-fakturuj',
      title: 'Najpierw postój, potem fakturowanie',
      description:
        '„Przekaż do fakturowania” jest nieaktywne, dopóki postój nie jest rozstrzygnięty. „Nalicz postój” bierze wyliczoną kwotę, „Nie naliczaj” wymaga powodu. Korektę (ujemna = obniżka) dodaje się z kwotą, walutą i powodem.',
      action: 'Kliknij „Nalicz postój” albo „Nie naliczaj”, a potem „Przekaż do fakturowania”.',
      recorder: {
        account: 'adm',
        actions: [{ kind: 'clickText', text: 'DEMO/2026/10/RZ1' }],
      },
    },
    {
      route: '/settlements',
      target: 'settlement-history',
      title: 'Historia decyzji',
      description:
        'Każda decyzja — postój, korekta, przekazanie do fakturowania — ma autora, czas i powód. To samo widać w historii zlecenia na jego karcie. Rozliczenia przekazanego do fakturowania nie da się już zmienić.',
      action: 'Przełącz listę na „Przekazane do fakturowania” i otwórz rozliczenie.',
      recorder: {
        account: 'adm',
        actions: [
          { kind: 'click', target: 'settlement-state-invoicing' },
          { kind: 'clickText', text: 'DEMO/2026/10/RZ2' },
        ],
      },
    },
    {
      route: '/suggestion-parameters',
      target: 'suggestion-parameter-settlementStopRateEur',
      title: 'Stawka postoju i czas bezpłatny',
      description:
        'Dwa parametry „Rozliczenie: postój” — czas bezpłatny przy punkcie (2 h) i stawka za godzinę ponad niego (40 EUR/h). To wartości robocze; zmiana wymaga powodu, ma właściciela i trafia do historii. Rozliczenie, w którym postój już rozstrzygnięto, zostaje przy kwocie z chwili decyzji.',
      action: 'Otwórz „Parametry rekomendacji”, przy parametrze kliknij „Zmień” i wpisz powód.',
      recorder: { account: 'admin' },
    },
  ],
};
